export const game_rules = (t) => ({
	symbols: [
		{
			title: t('gameRules.symbol_payout'),
			desc: t('gameRules.symbol_content')
		}
	],
	additional_symbols: [
		{
			title: t('gameRules.wild'),
			desc: t('gameRules.wild_content')
		},
		{
			title: t('gameRules.scatter'),
			desc: t('gameRules.scatter_content')
		}
	],
	paylines: [
		{
			title: t('gameRules.winning_paylines'),
			desc: t('gameRules.winning_paylines_content')
		}
	],
	features: [
		{
			title: t('gameRules.double_chance_and_buy_bonus'),
			double_desc_1: t('gameRules.double_chance_desc_1'),
			double_desc_2: t('gameRules.double_chance_desc_2'),
			bonus_desc_1: t('gameRules.bonus_desc_1'),
			bonus_desc_2: t('gameRules.bonus_desc_2'),
			bonus_desc_3: t('gameRules.bonus_desc_3'),
			double_change: t('gameRules.double_change')
		}
	]
});
